var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19489 6.21993C5.93504 6.51242 5.93504 6.98791 6.19489 7.2804L10.3926 12L6.19489 16.7196C5.93504 17.0121 5.93504 17.4876 6.19489 17.7801C6.45475 18.0733 6.88118 18.0733 7.14103 17.7801L11.8051 12.5302C12.065 12.2377 12.065 11.7623 11.8051 11.4698L7.14103 6.21993C6.88118 5.92669 6.45475 5.92669 6.19489 6.21993Z",
    fill: "#DFA04A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1949 6.21993C11.935 6.51242 11.935 6.98791 12.1949 7.2804L16.3926 12L12.1949 16.7196C11.935 17.0121 11.935 17.4876 12.1949 17.7801C12.4547 18.0733 12.8812 18.0733 13.141 17.7801L17.8051 12.5302C18.065 12.2377 18.065 11.7623 17.8051 11.4698L13.141 6.21993C12.8812 5.92669 12.4547 5.92669 12.1949 6.21993Z",
    fill: "#DFA04A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1c846f44cad6d0d0b00592e813afaf8a.svg";
export { ForwardRef as ReactComponent };